<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="section-6">
<h1>7</h1>
<p>Belfast is no longer the Belfast of my childhood, boyhood, and youth.</p>
<p>I make my way to where there was once a graceful Edwardian building in place of which now stands a steel and glass carbuncle. I enter to get the Coroner’s report on the death of Patrick Ford. I come out two hours later ready for lunch.</p>
<p>I join a queue for a 12 inch Italian herb and cheese sub with Italian BMT, salad works, thousand island dressing, and a fruit shoot, which I eat in the grounds of the City Hall, and mull over the coroner’s report.</p>
<p>The coroner recorded an open verdict, the jury confirming Patrick’s death was suspicious, but unable to reach any other verdict open to them.</p>
<p>Steven Ford, six months before he testified against Blair and Scott, had read this report.</p>
<p>The names of the four on and around that scaffold at the time Patrick came off it, are, David Nelson, Maurice Ellis, Paul Carley, and John Blair.</p>
<p>I phone Ollie Black. “Ollie, where do I find Sammy Payne?”</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch011.vue?3b323974